export const SUPPORTED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const EXCLUDED_CATEGORY_CODES = ['POI'];

export const readDocument = (fileHandle: File): Promise<Uint8Array> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = function() {
      const arrayBuffer = fileReader.result;
      const bytes = new Uint8Array(arrayBuffer as ArrayBufferLike);
      resolve(bytes);
    };

    fileReader.onerror = () => {
      reject(new Error('Read failed'));
    };

    fileReader.readAsArrayBuffer(fileHandle);
  });
};

export const formatFileSize = (size: number) => {
  if (size <= 0) {
    return '0 B';
  }
  const units = ['B', 'kB', 'MB', 'GB', 'TB'];
  const digitGroups = Math.min(Math.floor(Math.log10(size) / Math.log10(1024)), units.length - 1);

  const value = new Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 1
  }).format(size / 1024 ** digitGroups);

  return `${value} ${units[digitGroups]}`;
};
